// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-profile-landing-page-js": () => import("./../../../src/templates/profile-landing-page.js" /* webpackChunkName: "component---src-templates-profile-landing-page-js" */)
}

